import { jsx as _jsx } from "react/jsx-runtime";
import { IntlNumberField, DployTextField, IntlKeyboardDatePicker, IntlKeyboardTimePicker, IntlKeyboardDateTimePicker, IntlTimePicker, IntlDateTimePicker, IntlDatePicker } from "@ploy-ui/form-fields";
export const getNumberEdit = (column, format) => ({ onChange, value, columnDef }) => {
    const placeholder = typeof columnDef.title === "string" ? columnDef.title : undefined;
    return (_jsx(IntlNumberField, { format: format, ...column.editFormatOptions, onChange: onChange, value: value, placeholder: placeholder, percentValueAsFraction: column.type === "percentFraction", 
        // label={columnDef.title || " "}
        variant: "standard", margin: "dense" }));
};
export const getDateEdit = (column, format) => ({ onChange, value, columnDef }) => {
    const placeholder = typeof columnDef.title === "string" ? columnDef.title : undefined;
    const Picker = column.editFormatOptions
        ? IntlKeyboardDatePicker
        : IntlDatePicker;
    return (_jsx(Picker, { format: format, ...(column.editFormatOptions ?? column.formatOptions), onChange: onChange, value: value, placeholder: placeholder, 
        // label={columnDef.title || " "}
        inputVariant: "standard", margin: "dense" }));
};
export const getTimeEdit = (column, format) => ({ onChange, value, columnDef }) => {
    const placeholder = typeof columnDef.title === "string" ? columnDef.title : undefined;
    const Picker = column.editFormatOptions
        ? IntlKeyboardTimePicker
        : IntlTimePicker;
    return (_jsx(Picker, { format: format, ...(column.editFormatOptions ?? column.formatOptions), onChange: onChange, value: value, placeholder: placeholder, 
        // label={columnDef.title || " "}
        inputVariant: "standard", margin: "dense" }));
};
export const getDateTimeEdit = (column, format) => ({ onChange, value, columnDef }) => {
    const placeholder = typeof columnDef.title === "string" ? columnDef.title : undefined;
    const Picker = column.editFormatOptions
        ? IntlKeyboardDateTimePicker
        : IntlDateTimePicker;
    return (_jsx(Picker, { format: format, ...(column.editFormatOptions ?? column.formatOptions), onChange: onChange, value: value, placeholder: placeholder, 
        // label={columnDef.title || " "}
        inputVariant: "standard", margin: "dense" }));
};
export const TextEdit = ({ onChange, value, columnDef }) => {
    const placeholder = typeof columnDef.title === "string" ? columnDef.title : undefined;
    const modifiedOnChange = (e) => onChange(e.currentTarget.value);
    return (_jsx(DployTextField, { onChange: modifiedOnChange, value: value, placeholder: placeholder, 
        // label={columnDef.title || " "}
        variant: "standard", margin: "dense" }));
};
//# sourceMappingURL=cellEditors.js.map